import {
  adminMetricsApis,
  auditLogApis,
  meetingIssuesApis,
  studentInsightsApis,
  systemHealthApis,
} from '@shared/apis';
import {
  genericMutation,
  genericMutationWithId,
  genericQuery,
  genericQueryWithId,
  genericQueryWithParams,
} from './generics';

export const useGetMonthlyMetrics = genericQueryWithParams<adminMetricsApis.GetMonthlyMetrics>(
  adminMetricsApis.getMonthlyMetrics
);

export const useGetReschedulesByMentor =
  genericQueryWithParams<adminMetricsApis.GetReschedulesByMentor>(
    adminMetricsApis.getReschedulesByMentor
  );

export const useGetDurationMetrics = genericQueryWithParams<adminMetricsApis.GetDurationMetrics>(
  adminMetricsApis.getDurationMetrics
);

export const useGetEducationStrategistTime =
  genericQueryWithParams<adminMetricsApis.GetEducationStrategistTime>(
    adminMetricsApis.getEducationStrategistTime
  );

export const useGetEducationStrategistWorkload =
  genericQueryWithParams<adminMetricsApis.GetEducationStrategistWorkload>(
    adminMetricsApis.getEducationStrategistWorkload
  );

export const useGetSystemMeetingMetrics =
  genericQueryWithParams<adminMetricsApis.GetSystemMeetingMetrics>(
    adminMetricsApis.getSystemMeetingMetrics
  );

export const useGetUniversityResults =
  genericQueryWithParams<adminMetricsApis.GetUniversityResults>(
    adminMetricsApis.getUniversityResults
  );

export const useGetSessionQualityScores =
  genericQueryWithParams<adminMetricsApis.GetSessionQualityScores>(
    adminMetricsApis.getSessionQualityScores
  );

export const useGetSessionQualityScoresExport =
  genericQueryWithParams<adminMetricsApis.GetSessionQualityScoresExport>(
    adminMetricsApis.getSessionQualityScoresExport
  );

export const useGetMentorQualityScores =
  genericQueryWithParams<adminMetricsApis.GetMentorQualityScores>(
    adminMetricsApis.getMentorQualityScores
  );

export const useGetQualityScoringRuns =
  genericQueryWithParams<adminMetricsApis.GetQualityScoringRuns>(
    adminMetricsApis.getQualityScoringRuns
  );

export const useGetAdmissionResults = genericQuery<adminMetricsApis.GetAdmissionResults>(
  adminMetricsApis.getAdmissionResults
);

export const useGetSystemHealth = genericQuery<systemHealthApis.GetSystemHealth>(
  systemHealthApis.getSystemHealth
);

export const useGetStudentTimeline = genericQueryWithId<studentInsightsApis.GetStudentTimeline>(
  studentInsightsApis.getStudentTimeline
);

export const useGetAtRiskStudents = genericQuery<studentInsightsApis.GetAtRiskStudents>(
  studentInsightsApis.getAtRiskStudents
);

export const useGetMeetingIssues = genericQueryWithParams<meetingIssuesApis.GetMeetingIssues>(
  meetingIssuesApis.getMeetingIssues
);

export const useGetMeetingErrorDetails =
  genericQueryWithId<meetingIssuesApis.GetMeetingErrorDetails>(
    meetingIssuesApis.getMeetingErrorDetails
  );

export const useArchiveNoAudioDeadLetters =
  genericMutation<systemHealthApis.ArchiveNoAudioDeadLetters>(
    systemHealthApis.archiveNoAudioDeadLetters,
    systemHealthApis.getSystemHealth.endpoint
  );

export const useRunCronTaskNow = genericMutation<systemHealthApis.RunCronTaskNow>(
  systemHealthApis.runCronTaskNow,
  systemHealthApis.getSystemHealth.endpoint
);

export const useSearchAuditLogs = genericQueryWithParams<auditLogApis.SearchAuditLogs>(
  auditLogApis.searchAuditLogs
);

export const useGetAuditLogFilterOptions = genericQuery<auditLogApis.GetAuditLogFilterOptions>(
  auditLogApis.getAuditLogFilterOptions
);

export const useGetAdmissionTiers = genericQuery<adminMetricsApis.GetAdmissionTiers>(
  adminMetricsApis.getAdmissionTiers
);

export const useUpdateAdmissionTiers = genericMutationWithId<adminMetricsApis.UpdateAdmissionTiers>(
  adminMetricsApis.updateAdmissionTiers
);

export const useSeedAdmissionTiers = genericMutation<adminMetricsApis.SeedAdmissionTiers>(
  adminMetricsApis.seedAdmissionTiers
);
